<template>
  <div>
    <a-row>
      <a-col :span="6">
        <a-tree
          :key="loadKey"
          v-model="checkedKeys"
          :selected-keys="selectedKeys"
          :tree-data="treeData"
          default-expand-all
          show-icon
          @expand="onExpand"
          @select="onSelect"
        >
          <a-icon slot="doc" type="file-text" />
        </a-tree>
      </a-col>
      <a-col :span="2" class="button-box">
        <a-button @click="addMenuReady('menu')">新增子菜单</a-button>
        <a-button @click="addMenuReady('doc')">新增子文档</a-button>
        <a-button @click="deleteSlot">删除文档/菜单</a-button>
        <a-button @click="updateTitleReady('update')">修改名称</a-button>
        <a-button @click="editDoc">编辑文档</a-button>
      </a-col>
      <a-col :span="16">
        <a-table bordered :pagination="false" :data-source="dataSource" :columns="columns" :rowKey="record => record.id"></a-table>
      </a-col>
    </a-row>
    <a-modal title="标题" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="visible = false">
      菜单标题：
      <a-input v-model="editObj.title" style="width: 250px" />
      <br /><br />
      文档标题：
      <a-input v-model="editObj.doc_title" style="width: 250px" />
    </a-modal>
  </div>
</template>
<script>
import { createDocmenu, deleteDocmenu, getDocmenuList, updateDocmenuTitle } from '@/api/docmenu'

export default {
  data() {
    return {
      loadKey: 1,
      expandedKeys: ['全部文档'],
      autoExpandParent: true,
      checkedKeys: ['全部文档'],
      selectedKeys: [],
      treeData: [
        {
          title: '全部文档',
          key: '全部文档',
          children: []
        }
      ],
      visible: false,
      confirmLoading: false,
      editObj: {
        title: '',
        doc_title: ''
      },
      repeatObj: { 全部文档: { type: 'menu', level: 0, id: 0 } }, // 保存所有标题，防重复,
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          width: '10%'
        },
        {
          title: '名称',
          dataIndex: 'menu_title'
        },
        {
          title: '创建人',
          dataIndex: 'create_user',
          width: '10%'
        },
        {
          title: '创建时间',
          dataIndex: 'create_date',
          width: '15%'
        },
        {
          title: '更新人',
          dataIndex: 'update_user',
          width: '10%'
        },
        {
          title: '更新时间',
          dataIndex: 'update_date',
          width: '15%'
        }
      ],
      dataSource: []
    }
  },
  watch: {
    checkedKeys(val) {
      console.log('onCheck', val)
    },
    visible() {
      if (!this.visible) {
        this.editObj.title = ''
      }
    }
  },
  created() {
    this.getAllMenu()
  },
  methods: {
    getAllMenu() {
      getDocmenuList().then(res => {
        const levelObj = { 1: [], 2: [], 3: [] }
        res.data.map(x => {
          if (!levelObj[x.level]) {
            levelObj[x.level] = []
          }
          levelObj[x.level].push({ title: x.menu_title, key: x.id, slots: { icon: x.type }, ...x })
          this.repeatObj[x.id] = x
        })
        levelObj[2] = this.findFatherMethod(levelObj[2], levelObj[3])
        levelObj[1] = this.findFatherMethod(levelObj[1], levelObj[2])
        this.treeData[0].children = levelObj[1]
        this.loadKey++
      })
    },
    onExpand(expandedKeys) {
      console.log('onExpand', expandedKeys)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onCheck(checkedKeys) {
      console.log('onCheck', checkedKeys)
      this.checkedKeys = checkedKeys
    },
    onSelect(selectedKeys) {
      this.selectedKeys = selectedKeys
      if (this.selectedKeys.length && this.repeatObj[this.selectedKeys[0]]) {
        this.dataSource = [this.repeatObj[this.selectedKeys[0]]]
      } else {
        this.dataSource = []
      }
      // this.selectedKeys.length ? this.dataSource = [this.repeatObj[this.selectedKeys[0]]] : []
    },
    addMenuReady(type) {
      if (!this.selectedKeys.length) {
        this.$message.warning('未选择菜单节点')
        return
      }
      if (this.repeatObj[this.selectedKeys[0]].type === 'doc') {
        this.$message.warning('所选节点为文档，无法新增下级')
        return
      }
      this.createType = type
      this.visible = true
    },
    updateTitleReady(type) {
      if (!this.selectedKeys.length) {
        this.$message.warning('未选择菜单节点')
        return
      }
      this.createType = type

      const data = this.repeatObj[this.selectedKeys[0]]
      console.log(data)
      this.editObj = { title: data.menu_title, doc_title: data.doc_title }
      this.visible = true
    },
    handleOk() {
      if (!this.editObj.title || !this.editObj.doc_title) {
        this.$message.warning('未填写标题')
        return
      }
      // if (this.repeatObj[this.editObj.title]) {
      //   this.$message.warning('标题重复')
      //   return
      // }
      const checkedKey = this.repeatObj[this.selectedKeys[0]]
      if (checkedKey.level === 2 && this.createType === 'menu') {
        this.$message.warning('已经是底层菜单，只能新增文档')
        return
      }
      if (checkedKey.level === 3 && this.createType !== 'update') {
        this.$message.warning('已经是底层菜单，不能新增')
        return
      }
      if (this.createType === 'update') {
        updateDocmenuTitle({ id: checkedKey.id, ...this.editObj }).then(() => {
          this.$message.success('修改成功')
          this.getAllMenu()
          this.visible = false
        })
      } else {
        createDocmenu({ ...this.editObj, parent_id: checkedKey.id, type: this.createType, level: checkedKey.level + 1 }).then(() => {
          this.$message.success('创建成功')
          this.getAllMenu()
          this.visible = false
        })
      }
    },
    findFatherMethod(father, children) {
      father.map(x => {
        children.map(y => {
          if (y.parent_id === x.id) {
            x.children ? x.children.push(y) : (x.children = [y])
          }
        })
      })
      return father
    },
    deleteSlot() {
      if (!this.selectedKeys.length) {
        this.$message.warning('未选择菜单节点')
        return
      }
      const that = this
      this.$confirm({
        title: '确认删除所选菜单/文档?',
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          deleteDocmenu({ id: that.repeatObj[that.selectedKeys[0]].id }).then(() => {
            that.getAllMenu()
          })
        }
      })
    },
    editDoc() {
      if (!this.selectedKeys.length) {
        this.$message.warning('未选择菜单节点')
        return
      }
      const checkedKey = this.repeatObj[this.selectedKeys[0]]
      if (checkedKey.type !== 'doc') {
        this.$message.warning('所选不是文档')
        return
      }
      this.$router.push({ name: 'DocEdit', query: { id: checkedKey.id } })
    }
    // deleteTreeSlot(id) {
    //   this.treeData[0]
    // }
  }
}
</script>
<style scoped>
.button-box button {
  margin-top: 10px;
}
</style>
